var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDenimwear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.68 18.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    strokeWidth: 0,
    d: "M11.34,18.9c-.2,0-.39-.1-.49-.27L.08.83c-.1-.17-.1-.38,0-.55.1-.17.29-.28.49-.28h21.54c.2,0,.39.11.49.28.1.17.1.38,0,.55l-10.77,17.79c-.1.17-.29.27-.49.27M1.56,1.1l9.77,16.15L21.11,1.1H1.56Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenimwear);
export default __webpack_public_path__ + "static/media/DENIMWEAR.693f729ed409400759cc3892d72ff07f.svg";
export { ForwardRef as ReactComponent };